// src/main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { sentryInit, Sentry } from "./instrumentation/sentry";
import CrashFallback from "./components/CrashFallback";
import "./index.css";

// Initialise Sentry before the React tree is mounted so the SDK can intercept
// errors that occur during bootstrap.  No-ops if VITE_SENTRY_DSN is not set.
sentryInit();

// ── Global error handlers ─────────────────────────────────────────────────
// Catch uncaught errors and unhandled rejections so the app never silently
// crashes with a white screen. Sentry's SDK also captures these, but these
// handlers ensure we log to the console even if VITE_SENTRY_DSN is not set.

window.addEventListener("error", (event) => {
  console.error("[global] Uncaught error:", event.error ?? event.message);
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("[global] Unhandled promise rejection:", event.reason);
});
// ──────────────────────────────────────────────────────────────────────────

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<CrashFallback />} showDialog={false}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
